import TicketStatusCloseResolutions from './TicketStatusCloseResolutions';

export default TicketStatusCloseResolutions;
